import {EditProps} from "react-admin";
import {DefaultEdit} from "../../components/DefaultEdit";
import {LoadRouteForm} from "./LoadRouteForm";

export const LoadRouteEdit = (props: EditProps) => {
  return (
    <DefaultEdit {...props}>
      <LoadRouteForm />
    </DefaultEdit>
  );
};
